module.exports = __webpack_public_path__ + "static/media/cardPay.ffcbfdbb.svg";